export const TECHNICI = [
  { id: '1', fullName: 'Tomáš Raška', email: 'tomas.raska@derator.cz', kmRate: 5.5 },
  { id: '1007', fullName: 'Pavel Sedláček', email: 'pavel.sedlacek@derator.cz', kmRate: 1.0 },
  { id: '1011', fullName: 'Filip Landovský', email: 'filip.landovsky@derator.cz', kmRate: 5.5 },
  { id: '1012', fullName: 'Libor Landovský', email: 'libor.landovsky@derator.cz', kmRate: 5.5 },
  { id: '1013', fullName: 'Jaromír Mareš', email: 'jaromir.mares@derator.cz', kmRate: 5.5 },
  { id: '1027', fullName: 'Petr Sedláček', email: 'petr.sedlacek@derator.cz', kmRate: 5.5 },
  { id: '1042', fullName: 'Radek Steppan', email: 'radek.steppan@derator.cz', kmRate: 5.5 },
  { id: '1044', fullName: 'Adam Duda', email: 'adam.duda@derator.cz', kmRate: 5.5 },
  { id: '1048', fullName: 'Vladimír Nedopil', email: 'vladimir.nedopil@derator.cz', kmRate: 5.5 },
  { id: '1050', fullName: 'Lukáš Franěk', email: 'lukas.franek@derator.cz', kmRate: 5.5 },
];

export const DEV_VIEW_ALL_EMAILS = new Set(['pavel.sedlacek@derator.cz']);

export const normalizeEmail = (value) => String(value || '').trim().toLowerCase();

export function getEmployeeByEmail(userEmail) {
  const normalized = normalizeEmail(userEmail);
  return TECHNICI.find((item) => normalizeEmail(item.email) === normalized) || null;
}

export function getEmployeeIdByEmail(userEmail) {
  const employee = getEmployeeByEmail(userEmail);
  return employee ? employee.id : '';
}

export function isAdminEmail(userEmail) {
  return DEV_VIEW_ALL_EMAILS.has(normalizeEmail(userEmail));
}
